import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/nfse/teste/notafiscal/';

class NotaFiscalTesteService {
    constructor() {
        this.idCliente = null;
        this.idContribuinte = null;
        this.idUsuario = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    validar(notaFiscal, tipoTomador) {
        return axios.post(API_URL + 'validar?tipoTomador=' + tipoTomador, JSON.stringify(notaFiscal), { headers: this.headers });
    }

    saveLote(notasFiscais, tipoTomador) {
        return axios.post(API_URL + 'createLote?tipoTomador=' + tipoTomador, JSON.stringify(notasFiscais),
            { headers: this.headers });
    }

    save(notaFiscal, tipoTomador) {
        if (notaFiscal.visualizar) {
            return axios({
                url: API_URL + "create?tipoTomador=" + tipoTomador,
                method: "POST",
                responseType: "blob",
                data: JSON.stringify(notaFiscal),
                headers: this.headers
            }).then(response => {
                var fileURL = window.URL.createObjectURL(
                    new Blob([response.data], { type: "application/pdf" })
                );
                window.open(fileURL);
                console.log(response.data);
            }).catch((error) => {
                console.log(error);
            })
        } else {
            return axios.post(API_URL + 'create?tipoTomador=' + tipoTomador, JSON.stringify(notaFiscal),
                { headers: this.headers });
        }
    }

    listAllFiltroPesquisar(docTomador, docIntermediario, numero, rpsNumero, dataIni, dataFin, notaAvulsa, situacao) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        this.idNfsPessoa = LoginService.currentUserValue.contribuinte.idNfsPessoa;
        return axios.get(API_URL + 'consulta_v3?idCliente=' + this.idCliente
            + '&idNfsPessoa=' + this.idNfsPessoa
            + '&idContribuinte=' + this.idContribuinte
            + '&docTomador=' + docTomador
            + '&docIntermediario=' + docIntermediario
            + '&numero=' + numero
            + '&rpsNumero=' + rpsNumero
            + '&notaAvulsa=' + notaAvulsa
            + (dataIni ? ('&dataIni=' + dataIni) : "")
            + (dataFin ? ('&dataFin=' + dataFin) : "")
            + '&situacao=' + situacao,
            { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    listDeclaracoes(tipo, id) {
        return axios.get(API_URL + 'consultaDeclaracoes?tipo=' + tipo + '&id=' + id,
            { headers: this.headers }).then(response => (this.data = response.data));
    }

    listNotasByRps(idCliente, idRps) {
        return axios.get(API_URL + 'findByRps?idCliente=' + idCliente
            + '&idRps=' + idRps,
            { headers: this.headers }).then(response => (this.data = response.data))
    }

    cancelar(idNotaFiscal, observacao, isTermoCancelamento, validacao, cancDamPetrolina) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idUsuario = LoginService.currentUserValue.usuario.idUsuario;
        return axios.post(API_URL + 'cancela?idCliente=' + this.idCliente
            + '&idUsuario=' + this.idUsuario
            + '&idNotaFiscal=' + idNotaFiscal
            + '&isTermoCancelamento=' + isTermoCancelamento
            + '&observacao=' + observacao
            + '&validar=' + validacao
            + '&cancDamPetrolina=' + cancDamPetrolina, null,
            { headers: this.headers });
    }

    anularTermoCancelamento(idNotaFiscal) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idUsuario = LoginService.currentUserValue.usuario.idUsuario;
        return axios.post(API_URL + 'desfazTermoCancelamento?idCliente=' + this.idCliente
            + '&idUsuario=' + this.idUsuario
            + '&idNotaFiscal=' + idNotaFiscal, null,
            { headers: this.headers });
    }

    aceiteCancelamento(idNotaFiscal, idAceite, observacao, observacaoTomador) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idUsuario = LoginService.currentUserValue.usuario.idUsuario;
        return axios.post(API_URL + 'aceiteCancelamento?idCliente=' + this.idCliente
            + '&idUsuario=' + this.idUsuario
            + '&idNotaFiscal=' + idNotaFiscal
            + '&idAceiteCancelamento=' + idAceite
            + '&observacao=' + observacao
            + '&observacaoTomador=' + observacaoTomador, null,
            { headers: this.headers });
    }

    negarCancelamento(idNotaFiscal, idAceite, observacaoTomador) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idUsuario = LoginService.currentUserValue.usuario.idUsuario;
        return axios.post(API_URL + 'negarCancelamento?idCliente=' + this.idCliente
            + '&idUsuario=' + this.idUsuario
            + '&idNotaFiscal=' + idNotaFiscal
            + '&idAceiteCancelamento=' + idAceite
            + '&observacaoTomador=' + observacaoTomador, null,
            { headers: this.headers });
    }

    desfazerCancelamento(idNotaFiscal) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idUsuario = LoginService.currentUserValue.usuario.idUsuario;
        return axios.post(API_URL + 'desfazerCancelamento?idCliente=' + this.idCliente
            + '&idUsuario=' + this.idUsuario
            + '&idNotaFiscal=' + idNotaFiscal, null,
            { headers: this.headers });
    }

    findByNumero(numeroNotaFiscal) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'findByNumero?idCliente=' + this.idCliente
            + '&idContribuinte=' + this.idContribuinte
            + '&numeroNotaFiscal=' + numeroNotaFiscal,
            { headers: this.headers });
    }

    findByNumeroCopiarNota(numeroNotaFiscal) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'findByNumeroCopiarNota?idCliente=' + this.idCliente
            + '&idContribuinte=' + this.idContribuinte
            + '&numeroNotaFiscal=' + numeroNotaFiscal,
            { headers: this.headers });
    }

    findByNotaSubstituicao(id) {
        return axios.get(API_URL + 'findByNotaSubstituicao?id=' + id,
            { headers: this.headers });
    }

    findById(idNotaFiscal) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'findById?idCliente=' + this.idCliente
            + '&idNotaFiscal=' + idNotaFiscal,
            { headers: this.headers });
    }

    findNotasCopiar(filtro, ano) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'findNotasCopiar?idCliente=' + this.idCliente + '&idContribuinte=' + this.idContribuinte + '&filtro=' + filtro + '&ano=' + ano,
            { headers: this.headers }).then(response => (this.data = response.data))
    }

    getUltimaEmitida() {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'ultimaEmitida?idCliente=' + this.idCliente + '&idContribuinte=' + this.idContribuinte, { headers: this.headers });
    }

    validarDadosTela(tipoTomador, idServico, localPrestacao, idTomador) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'validarDadosTela?idCliente=' + this.idCliente
            + '&idContribuinte=' + this.idContribuinte
            + '&tipoTomador=' + tipoTomador
            + '&idServico=' + idServico
            + '&localPrestacao=' + localPrestacao
            + '&idTomador=' + idTomador, { headers: this.headers });
    }


    validarDadosTelaRetencao(tipoTomador, idServico, idBolSomenteRetencao, localPrestacao, idTomador) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'validarDadosTelaComRetencao?idCliente=' + this.idCliente
            + '&idContribuinte=' + this.idContribuinte
            + '&tipoTomador=' + tipoTomador
            + '&idServico=' + idServico
            + '&idBolSomenteRetencao=' + idBolSomenteRetencao
            + '&localPrestacao=' + localPrestacao
            + '&idTomador=' + idTomador, { headers: this.headers });
    }


    validarDadosTelaNotaFiscal(tipoTomador, idServico, idBolSomenteRetencao, localPrestacao, idTomador, emissorNotaAvulsa, fatoGerador, pagaIssqnSomenteMunic) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'dadosTelaNotaFiscal?idCliente=' + this.idCliente
            + '&idContribuinte=' + this.idContribuinte
            + '&tipoTomador=' + tipoTomador
            + '&idServico=' + idServico
            + '&idBolSomenteRetencao=' + idBolSomenteRetencao
            + '&localPrestacao=' + localPrestacao
            + '&idTomador=' + idTomador
            + '&emissorNotaAvulsa=' + emissorNotaAvulsa
            + '&fatoGerador=' + fatoGerador
            + '&pagaIssqnSomenteMunic=' + pagaIssqnSomenteMunic, { headers: this.headers });
    }

    validarDadosTelaNotaFiscalV3(tipoTomador, idServico, idBolSomenteRetencao, localPrestacao, tipoRecolhimento, idTomador, emissorNotaAvulsa, fatoGerador, pagaIssqnSomenteMunic, idServicoNacional, exportacaoServico) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'dadosTelaNotaFiscalV3?idCliente=' + this.idCliente
            + '&idContribuinte=' + this.idContribuinte
            + '&tipoTomador=' + tipoTomador
            + '&idServico=' + idServico
            + '&idBolSomenteRetencao=' + idBolSomenteRetencao
            + '&localPrestacao=' + localPrestacao
            + '&tipoRecolhimento=' + tipoRecolhimento
            + '&idTomador=' + idTomador
            + '&emissorNotaAvulsa=' + emissorNotaAvulsa
            + '&fatoGerador=' + fatoGerador
            + '&pagaIssqnSomenteMunic=' + pagaIssqnSomenteMunic
            + '&idServicoNacional=' + idServicoNacional
            + '&exportacaoServico=' + exportacaoServico, { headers: this.headers });
    }

    validarSubstituicaoNotaFiscal(idNotaFiscal, valorServico, dataFatoGerador) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'validarSubstituicao?idCliente=' + this.idCliente
            + '&idNotaFiscal=' + idNotaFiscal
            + '&valorServico=' + valorServico
            + '&dataFatoGerador=' + dataFatoGerador,
            { headers: this.headers });
    }

    validarCancelamentoNfse(idNotaFiscal) {
        return axios.get(API_URL + 'validarCancelamentoNfse?idNotaFiscal=' + idNotaFiscal,
            { headers: this.headers });
    }

    validarAnaliseCancelamentoNfse(idNotaFiscal) {
        return axios.get(API_URL + 'validarAnaliseCancelamentoNfse?idNotaFiscal=' + idNotaFiscal,
            { headers: this.headers });
    }

    definirAnaliseCancelamentoNotaFiscal(idNotaFiscal, idNotaFiscalSituacao, resposta, observacaoFiscal) {
        this.idUsuario = LoginService.currentUserValue.usuario.idUsuario;
        return axios.post(API_URL + 'definirAnaliseCancelamentoNotaFiscal?idUsuario=' + this.idUsuario
            + '&idNotaFiscal=' + idNotaFiscal
            + '&idNotaFiscalSituacao=' + idNotaFiscalSituacao
            + '&resposta=' + resposta
            + '&observacaoFiscal=' + observacaoFiscal, null,
            { headers: this.headers });
    }

    enviarPorEmail(idNotaFiscal, emails, comentarios) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'enviarEmail?idCliente=' + this.idCliente
            + '&idNotaFiscal=' + idNotaFiscal
            + '&emails=' + emails
            + '&comentarios=' + comentarios,
            { headers: this.headers });
    }

    reenviarEmail(idCliente) {
        return axios.get(API_URL + 'reenvioUnimed?idCliente=' + idCliente,
            { headers: this.headers });
    }



    visualizar(rel, parametros, idNota, tipo = "pdf") {

        return axios({
            url: API_URL + "visualizar?idNotaFiscal=" + idNota,
            method: "POST",
            responseType: "blob",
            data: {
                rel: rel,
                tipo: tipo,
                parametros: parametros
            },
            headers: this.headers
        }).then(response => {
            var fileURL = window.URL.createObjectURL(
                new Blob([response.data], { type: "application/pdf" })
            );
            window.open(fileURL);
            console.log(response.data);
        });
    }

    termoSubstituicao(idCliente, idUsuario, idNotaFiscal, observacao) {
        return axios.post(API_URL + 'termoSubstituicao?idCliente=' + idCliente
            + '&idUsuario=' + idUsuario
            + '&idNotaFiscal=' + idNotaFiscal
            + '&observacao=' + observacao, null,
            { headers: this.headers });
    }

    solicitarExportacoNfse(idContribuinte, idUsuario, dataIni, dataFin, docTomador, idServicoItem, situacao, tipo) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.post(API_URL + 'solicitaExportacao?idCliente=' + this.idCliente
            + '&idContribuinte=' + idContribuinte
            + '&idUsuario=' + idUsuario
            + '&dataIni=' + dataIni
            + '&dataFin=' + dataFin
            + '&docTomador=' + docTomador
            + '&idServicoItem=' + idServicoItem
            + '&situacao=' + situacao
            + '&tipo=' + tipo, null,
            { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findSolicitExportNfse(idContribuinte) {
        return axios.get(API_URL + 'findSolicitContr?idContribuinte=' + idContribuinte,
            { headers: this.headers });
    }

    realizarSorteio(ano, mes) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'sortearNotaFiscal?idCliente=' + this.idCliente + '&ano=' + ano + '&mes=' + mes,
            { headers: this.headers });
    }

    salvarSorteio(idNotaFiscal, ano, mes) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'salvarSorteioNfse?idNotaFiscal=' + idNotaFiscal + '&idCliente=' + this.idCliente + '&ano=' + ano + '&mes=' + mes,
            { headers: this.headers });
    }

    findSorteiosNfse() {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'findAllSorteiosNfse?idCliente=' + this.idCliente,
            { headers: this.headers });
    }

    saveEmailBlacklist(blacklist) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.post(API_URL + 'saveEmailBlacklist?idCliente=' + this.idCliente, JSON.stringify(blacklist),
            { headers: this.headers });
    }

    saveEmailBlacklistContribuinte(blacklist) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.post(API_URL + 'saveEmailBlacklistContribuinte?idCliente=' + this.idCliente + '&idContribuinte=' + this.idContribuinte, JSON.stringify(blacklist),
            { headers: this.headers });
    }

    deleteEmailBlacklist(idEmailBlacklist) {
        return axios.get(API_URL + 'deleteEmailBlacklist?idEmailBlacklist=' + idEmailBlacklist,
            { headers: this.headers });
    }

    findAllEmailsBlacklist() {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'findAllEmailsBlacklist?idCliente=' + this.idCliente,
            { headers: this.headers });
    }

    findAllEmailsBlacklistContr() {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'findAllEmailsBlacklistContr?idCliente=' + this.idCliente + '&idContribuinte=' + this.idContribuinte,
            { headers: this.headers });
    }

    downloadDanfseHtml(idNota) {
        return axios.get(API_URL + 'findDanfseHtmlById?idNota=' + idNota, { headers: this.headers });
    }

    downloadDanfseHtmlByChaveNfse(idContribuinte, chaveNfse) {
        return axios.get(API_URL + 'findDanfseHtmlByChaveNfse?idContribuinte=' + idContribuinte + '&chaveNfse=' + chaveNfse, { headers: this.headers });
    }

    downloadXml(id) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios({
            url: API_URL + "exportXmlNFS?idNotaFiscal=" + id + "&idCliente=" + this.idCliente,
            method: "POST",
            responseType: "blob",
            data: null,
            headers: this.headers
        }).then(response => {
            const contentDisposition = response.headers["content-disposition"];
            let fileName = "NotaFiscal.xml";
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="(.+)"/);
                if (match && match.length > 1) {
                    fileName = match[1];
                } else {
                    const match2 = contentDisposition.match(/filename=([^;]+)/);
                    if (match2 && match2.length > 1) {
                        fileName = match2[1].trim();
                    }
                }
            }

            var fileURL = window.URL.createObjectURL(
                new Blob([response.data], { type: "application/xml" })
            );
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
        });
    }

}

export default new NotaFiscalTesteService();